/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Watch, Vue } from 'vue-property-decorator';
import { debounce } from 'lodash';
import { merge } from 'lodash';
import StoreDispatcher from '@service/StoreDispatcher';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            store: {},
            propsFilled: false,
        };
    },

    created() {
        this.store = merge(this.store, this.current);
    },

    methods: {
        putInStore: debounce(function(data) {
            return this._store(data);
        }, 1000),

        async _store(data) {
            return StoreDispatcher.updateCurrentProject(data).then(response => {
                if (response instanceof Error) {
                    this.errorData = this.getErrorMessage(response);
                    return false;
                }
                return true;
            });
        }
    }
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class StepStoreMixin extends Vue {
    @Watch('store', { deep: true })
    onStoreChange(val) {
        if (this.propsFilled)
            this.putInStore(val);

        if (!this.propsFilled) {
            this.propsFilled = true;
            
            if (this.onPropsFilled)
                this.onPropsFilled();
        }
    }
}